<form class="filter-form" [formGroup]="form">
  <p-accordion [(activeIndex)]="formsActiveIndex">
    <p-accordionTab header="UI компонента">
      <filter-ui-form [form]="form.controls.ui"></filter-ui-form>
    </p-accordionTab>

    <p-accordionTab header="Источник данных фильтра">
      <filter-datasource-form
        [form]="form.controls.datasource"
        [otherFilters]="otherFilters"
        [datasourceCopyData]="datasourceCopyData"
      ></filter-datasource-form>
    </p-accordionTab>

    <p-accordionTab header="Соответствие полей">
      <filter-mapping-form [form]="form.controls.mapping"></filter-mapping-form>
    </p-accordionTab>

    <p-accordionTab>
      <ng-template pTemplate="header">
        <div class="tab-header">
          Параметры шаблона

          <p-button
            class="only-icon"
            icon="pi"
            [size]="'small'"
            severity="secondary"
            [rounded]="true"
            [text]="true"
            [pTooltip]="'Добавить параметр'"
            [tooltipPosition]="'bottom'"
            (onClick)="addParamControl(); formsActiveIndex === 3 && $event.stopPropagation()"
          >
            <lucide-icon [img]="CirclePlusIcon" [size]="20"></lucide-icon>
          </p-button>
        </div>
      </ng-template>

      <p-tabView
        *ngIf="paramsControl.controls.length; else noDataParamsTmp"
        formArrayName="params"
        [activeIndex]="paramsActiveIndex"
        [controlClose]="true"
        (onClose)="closeTab($event)"
      >
        <ng-container *ngFor="let paramControl of paramsControl.controls; let paramIndex = index">
          <ng-container [formGroupName]="paramIndex">
            <p-tabPanel [header]="paramControl.value.parameter || 'Параметр ' + (paramIndex + 1)" [closable]="true">
              <filter-param-form [form]="paramControl"></filter-param-form>
            </p-tabPanel>
          </ng-container>
        </ng-container>
      </p-tabView>
    </p-accordionTab>
  </p-accordion>
</form>

<ng-template #noDataParamsTmp>
  <div class="no-data">Для добавления параметра нажмите кнопку (+)</div>
</ng-template>
